import React from 'react';
import { Link } from 'react-router-dom';

const MinimalNavbar = () => {
    return (
        <nav className="bg-white shadow-sm fixed w-full z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16 items-center">
                <Link to="/" className="flex items-center space-x-2">
                        <img 
                            src="/assets/Payrendr.png" 
                            alt="Payrendr Logo" 
                            className="h-8 w-auto"  
                        />
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default MinimalNavbar;
